import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert, Input } from 'reactstrap'
import Spinner from '../Spinner/Spinner.js'
import { COUNTRIES_QUERY } from '../../graphql.js'
import { handleGraphQLErrors } from '../../utils.js'

export const COUNTRIES = gql(COUNTRIES_QUERY)

export default function CountryInput({ handleChange, defaultValue }) {
  console.log('CountryInput rendered')

  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: COUNTRIES, fetchPolicy: 'cache-first' })
        if (data.countries) {
          const menuItems = [<option key={0} value={null}></option>]
          for (let item of data.countries) {
            menuItems.push(<option key={item.id} value={item.id}>{item.name}</option>)
          }
          setItems(menuItems)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  }, [items])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (items) {
    return (
      <Input style={{ display: 'inline-block', width: 'auto' }} type="select" name="country" className="state-input" onChange={handleChange} defaultValue={defaultValue} >
        {items}
      </Input>
    )
  } else {
    return <Spinner />
  }
}
